export default __webpack_public_path__ + "static/media/Cover_Page_Thumbnail.48182c99.png";